module.exports = __webpack_public_path__ + "img/3878.3545aa5d.jpg";